import { Inject, Injectable } from '@angular/core';
import { BaseService } from './Base.Service';
import { environment } from './../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppService<T extends any> extends BaseService<T> {
  constructor(@Inject(String) private appController: string) {

    super(appController, environment.apiUrl);
  }
}
